import type { MapStateToProps } from 'react-redux';
import { connect } from 'react-redux';
import { canDisplayDetail } from 'state/blotters/scheduledQuotes';
import type { AppState } from 'state/state.model';

interface StateProps {
  isBlotterPanelActive: boolean;
}
export type ScheduledQuotesBlotterProps = StateProps;

const mapStateToProps: MapStateToProps<StateProps, {}, AppState> = (appState: AppState): StateProps => ({
  isBlotterPanelActive: canDisplayDetail(appState),
});

export const connectScheduledQuotesBlotter = connect(mapStateToProps);
